import { format, parse } from "date-fns";

// API display formats: "29 Aug 2026" and "04:30 PM". Native inputs use yyyy-MM-dd and HH:mm.

export const toApiDate = (iso) => {
  if (!iso) return "";
  const d = parse(iso, "yyyy-MM-dd", new Date());
  return isNaN(d) ? iso : format(d, "d MMM yyyy");
};

export const fromApiDate = (api) => {
  if (!api) return "";
  const clean = String(api).replace(/(\d+)(st|nd|rd|th)/g, "$1").trim();
  for (const f of ["d MMM yyyy", "d MMMM yyyy", "MMMM d, yyyy", "MMM d, yyyy", "yyyy-MM-dd"]) {
    const d = parse(clean, f, new Date());
    if (!isNaN(d)) return format(d, "yyyy-MM-dd");
  }
  return "";
};

export const toApiTime = (hhmm) => {
  if (!hhmm) return "";
  const d = parse(hhmm, "HH:mm", new Date());
  return isNaN(d) ? hhmm : format(d, "hh:mm a");
};

export const fromApiTime = (api) => {
  if (!api) return "";
  const d = parse(String(api).trim(), "hh:mm a", new Date());
  return isNaN(d) ? "" : format(d, "HH:mm");
};

export const todayIso = () => format(new Date(), "yyyy-MM-dd");

export const inputCls =
  "h-11 w-full rounded-xl border border-pine/15 px-3.5 text-sm focus:outline-none focus:ring-2 focus:ring-pine bg-white";
export const labelCls = "text-xs font-bold text-pine/60";
